
import React from "react";
import { cn } from "@/lib/utils";

interface FormDividerProps {
  text?: string;
  className?: string;
}

const FormDivider: React.FC<FormDividerProps> = ({ 
  text = "or", 
  className 
}) => {
  return (
    <div className={cn("relative my-6", className)}>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-200"></div>
      </div>
      <div className="relative flex justify-center text-sm">
        <span className="px-2 bg-white text-gray-500">{text}</span>
      </div>
    </div>
  );
};

export default FormDivider;

